import * as React from 'react';

// Core imports.
import { StampPosition } from 'unspoken-core/lib/models/ClientModels';

interface StampProps {
  text: string;
  textColor: string;
  position: StampPosition;
  fadeOut: boolean;
  opacity: number;
}

const Stamp = (props: StampProps) => {
  
  let fontSize = 40;
  if (props.text.length > 15) {
    fontSize = 20;
  } else if (props.text.length > 10) {
    fontSize = 20;
  } else if (props.text.length > 6) {
    fontSize = 25;
  }

  return (
    <div 
      className={`attraction-stimulus__stamp attraction-stimulus__stamp--${props.position === StampPosition.LEFT ? 'left' : 'right'}`}
      style={{
        color: props.textColor,
        fontSize,
        opacity: props.opacity, 
        transition: props.fadeOut ? 'opacity .3s' : ''
      }}
    >
      {props.text}
    </div>
  );
};

export default Stamp;



// WEBPACK FOOTER //
// ./src/components/Stamp.tsx